




























import { Component, Vue, Prop } from "vue-property-decorator";
import StatBlock from "./StatBlock.vue";
import { ExtendedProjectModel } from "../models";
import dateflip from "shared/filters/dateflip";
import money from "shared/filters/money";

interface BlockData {
  label: string;
  value: string;
  tooltip: string;
  defaultValue?: string;
  titleFontSize?: string;
}

@Component({
  components: { StatBlock },
  filters: { dateflip, money },
})
export default class StatBlocks extends Vue {
  @Prop({ required: true, type: Object }) private value!: ExtendedProjectModel;

  get blockData(): BlockData[] {
    if (!this.value.selling_data) return [];
    const t = (key: string): string =>
      this.$t("houseprojects.statsBlocks.toSell." + key).toString();
    return [
      {
        label: t("purchasePrice.label"),
        value: this.$options.filters!.money(
          this.value.selling_data.purchase_price
        ),
        tooltip: t("purchasePrice.tooltip"),
      },
      {
        label: t("wozValue.label"),
        value: this.$options.filters!.money(this.value.selling_data.woz_value),
        tooltip: t("wozValue.tooltip"),
      },
      {
        label: t("commission.label"),
        value:
          this.value.selling_data.commission_fixed === 0 &&
          this.value.selling_data.commission_percentage > 0
            ? this.value.selling_data.commission_percentage.toString() + "%"
            : this.$options.filters!.money(
                this.value.selling_data.commission_fixed
              ),
        tooltip: t("commission.tooltip"),
      },
      {
        label: t("constructionYear.label"),
        value: this.value.selling_data.construction_year.toString(),
        tooltip: t("constructionYear.tooltip"),
      },
    ];
  }
}
